export default __webpack_public_path__ + "static/media/mus-oklahomasmokeshow.b7866170.mp4";